import {
  Outlet,
  RouterProvider,
  Link,
  createRouter,
  createRoute,
  createRootRoute,
  redirect,
} from "@tanstack/react-router";
import { HomePage } from "../pages/home/HomePage";
import { InfoPage } from "../pages/info/InfoPage";
import { RsvpPage } from "../pages/rsvp/RsvpPage";
import { Layout } from "../components/Layout";
import { AuthPage } from "../pages/auth/AuthPage";

async function getMe(): Promise<boolean> {
  const res = await fetch("/api/me", {
    credentials: "include",
  });
  return res.ok;
}

const rootRoute = createRootRoute({
  component: () => (
    <>
      <Layout>
        <Outlet />
      </Layout>
    </>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const infoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/info",
  component: InfoPage,
});

const rsvpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/rsvp",
  component: RsvpPage,
  beforeLoad: async ({ location }) => {
    const ok = await getMe();
    if (!ok) {
      throw redirect({
        to: "/auth",
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
});

const authRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth",
  component: AuthPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  infoRoute,
  rsvpRoute,
  authRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
